export default __webpack_public_path__ + "static/media/cgc.a639613c.svg";